import { IconRender } from "@/components/shared/Icon-render";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { GenericType } from "@/types";
export const TextInput = ({
  field,
  icon,
  placeholder,
  className,
  iconClassName,
}: GenericType) => {
  return (
    <div className="relative">
      {icon ? (
        <IconRender
          className={cn(
            "absolute left-2 top-0 bottom-0 my-auto z-[1]",
            iconClassName
          )}
          name={icon}
          strokeWidth={1}
          size={17}
        />
      ) : null}
      <Input
        className={cn({ "pl-8": icon }, className)}
        placeholder={placeholder}
        {...field}
      />
    </div>
  );
};
